import { Injectable } from '@angular/core';
import { HttpService } from "./http.service";
import { MerchantBillingViewModel } from '../models/merchant-billing-models/merchant-billing-view-model';

@Injectable({
  providedIn: 'root'
})
export class MerchantBillingReportsService {

  constructor(private _httpService: HttpService) {
  }

  public async GetById(id: number, date: string): Promise<MerchantBillingViewModel> {
    const httpResult = await this._httpService.apiGet<MerchantBillingViewModel>(`MerchantBillingReports/GetById/${id}/${date}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }
}
